import { render, staticRenderFns } from "./RevenueEditor.vue?vue&type=template&id=61df169a"
import script from "./RevenueEditor.vue?vue&type=script&lang=ts"
export * from "./RevenueEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports